import { UaePassDetailsScreen } from '@/modules/onboarding/identity/uae-pass-details';
import React from 'react';

export default function UaePassDetails() {
    return <UaePassDetailsScreen />;
}